import "core-js/modules/es.promise.finally.js";
import { isThenable } from '../../lib/is-thenable';
export var createTaskGroup = function createTaskGroup() {
  var taskCompletionPromise;
  var resolvePromise;
  var count = 0;
  return {
    done: function done() {
      return taskCompletionPromise;
    },
    run: function run(op) {
      var returnValue = op();
      if (isThenable(returnValue)) {
        if (++count === 1) {
          taskCompletionPromise = new Promise(function (res) {
            return resolvePromise = res;
          });
        }
        returnValue.finally(function () {
          return --count === 0 && resolvePromise();
        });
      }
      return returnValue;
    }
  };
};